export default "__VITE_ASSET__mp406O16__"